import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedFormsModule } from '@ot/shared/forms';
import { SharedQuestionsModule } from '@ot/shared/questions';
import { DynamicFormQuestionComponent } from './dynamic-form-question.component';
import { DynamicFormComponent } from './dynamic-form.component';

@NgModule({
  declarations: [DynamicFormComponent, DynamicFormQuestionComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedQuestionsModule,
    SharedFormsModule
  ],
  exports: [
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    SharedFormsModule
  ]
})
export class DynamicFormModule {}
